// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"730":"c6d83f35","767":"626f626f","956":"cf3c92a8","989":"88b753ce"}[chunkId] + ".chunk.js";
};